import React, { useState } from 'react';
import './ContactUs.css';
import ContactService from '../services/ContactService';
import ContactAdmin from '../components/ContactAdmin';
import CompanyLogo from '../images/VerticalLogo.png';

function ContactUs() {

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus('');

    const contactData = {
      name,
      email,
      subject, 
      message,
    };

    try {
      console.log('Submitting contact form:', contactData);
      const result = await ContactService.sendContactForm(contactData);
      
      if (result.success) {
        setStatus(result.message);
        setSuccess(true);
        setName('');
        setEmail('');
        setSubject('');
        setMessage('');
        
        // Show additional note if available
        if (result.note) {
          setTimeout(() => {
            setStatus(prev => prev + ' ' + result.note);
          }, 2000);
        }
      } else {
        setStatus(result.message);
        setSuccess(false);
        
        // Log detailed error information for debugging
        if (result.details) {
          console.error('Contact form error details:', result.details);
        }
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setStatus('An unexpected error occurred. Please try again.');
      setSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="contact-container container my-5">
      <div className="row">
        <div className="col-12">
          <h2 style={{ color: '#000000'}}>Contact Us</h2>
          {/* <form className="contact-us-form" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">Name</label>
              <input 
                type="text" 
                className="form-control" 
                id="name" 
                placeholder="Your Name" 
                value={name} 
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input 
                type="email" 
                className="form-control" 
                id="email" 
                placeholder="you@example.com" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="subject" className="form-label">Subject</label>
              <input 
                type="text" 
                className="form-control" 
                id="subject" 
                placeholder="Subject" 
                value={subject} 
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="message" className="form-label">Message</label>
              <textarea 
                className="form-control" 
                id="message" 
                rows="4" 
                placeholder="Your message here..." 
                value={message} 
                onChange={(e) => setMessage(e.target.value)}
                required
              ></textarea>
            </div>
            <button 
              type="submit" 
              className="btn btn-primary d-block mx-auto" 
              style={{backgroundColor: 'transparent', border: '2px solid #BFD42F', color: '#000', borderRadius:'16px'}}
              disabled={isLoading}
            >
              {isLoading ? 'Sending...' : 'Send Message'}
            </button>
          </form> */}
          {status && (
            <p style={{color: success ? 'green' : 'red', marginTop: '15px'}}>{status}</p>
          )}
        </div>
      </div>

      {/* Simple Contact Information Display */}
    <div className="contact-info-box mt-4">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="info-card p-4 text-center" style={{
              backgroundColor: '#f8f9fa',
              border: '2px solid #BFD42F',
              borderRadius: '12px',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}>
              <h4 style={{ color: '#000', marginBottom: '20px' }}>Email: contactus@cloudvisorwealth.com</h4>
              <div style={{ fontSize: '16px', lineHeight: '1.6' }}>
                {/* <p style={{ margin: '8px 0', fontWeight: '500' }}>
                  <strong>Mitch Benton</strong>
                </p> */}
                {/* <p style={{ margin: '8px 0', color: '#666' }}>
                  Cloudvisor Wealth
                </p> */}
                {/* <p style={{ margin: '8px 0' }}>
                  <a href="#" style={{ 
                    color: '#000000ff', 
                    textDecoration: 'none',
                    fontWeight: '500'
                  }}>
                    contactus@cloudvisorwealth.com
                  </a>
                </p> */}
                <p style={{ margin: '8px 0', color: '#666' }}>
                  <img src={CompanyLogo} alt="Cloudvisor Wealth" style={{ maxWidth: '150px', height: 'auto' }} />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
      <footer className="site-footer">
        <div className="container text-center">
            <p>&copy; {new Date().getFullYear()} Cloudvisor DigitalAssociate. All rights reserved.</p>
        </div>
    </footer>
    
    {/* Admin component for viewing stored messages (development only) */}
    <ContactAdmin />
    
    
    </div>
  );
}

export default ContactUs;